import { Backdrop, CircularProgress, Paper, Stack, Typography } from '@mui/material';
import { FunctionComponent } from 'react';

type Props = {
	loading: boolean;
	label: string;
};

export const LoadingOverlay: FunctionComponent<Props> = (props) => {
	return <Backdrop open={props.loading}>
		<Paper
			sx={{ width: '25%', minWidth: 200, padding: 4 }}
			elevation={3}
			role="status"
			aria-live="polite"
			aria-atomic="true"
		>
			<Stack direction='column' spacing={2} sx={{ alignItems: 'center' }}>
				<CircularProgress aria-labelledby='loading-label' />
				<Typography variant='body1' aria-labelledby='loading-label'>{props.label}...</Typography>
			</Stack>
		</Paper>
	</Backdrop >;
};